import { useLocalization } from '@shopify/hydrogen'
import { I18nContext, I18nManager, useI18n as useShopifyI18n } from '@shopify/react-i18n'
import { PropsWithChildren } from 'react'
import en from '../assets/translations/en.json'
import fr from '../assets/translations/fr.json'

export const localeRegex = /^\/([a-z]{2})-([a-z]{2})(\/|$)/i

export const useI18n = () => {
  return useShopifyI18n({
    id: 'translations',
    fallback: en,
    translations(locale: string) {
      if (locale === 'fr') {
        return fr
      }
    },
  })
}

export const I18n: React.FC<PropsWithChildren> = ({ children }) => {
  const {
    language: { isoCode: language },
    country: { isoCode: country },
  } = useLocalization()

  const i18nManager = new I18nManager({
    locale: language.toLowerCase(),
    country: country.toLowerCase(),
    onError: () => {},
  })

  return <I18nContext.Provider value={i18nManager}>{children}</I18nContext.Provider>
}
